<template>
  <Dialog :expanderClass="'d-inline'" ref="recurranceModal" panelClass="bui-dialog-panel">
    <template #expander="{ openModal }">
      <a @click="openModal"> {{ form.type == 0 ? 'All Day, Every Day' : "Custom Recurrence" }}</a>

    </template>
    <template #dialog.title>
      Edit Recurrence
      <h6 class="mb-3">
        {{ playlist.playlist.name }}
      </h6>
    </template>
    <template #dialog.content="{ closeModal, closeModalAfter }">
      <div class="recurrence-form">
        <div class="rf-type-row">
          <span class="rf-label">Recurrence:</span>
          <label class="rf-check">
            <input type="radio" name="inlineRadioOptions" v-model="form.type" :value="0">
            All Day, Every Day
          </label>
          <label class="rf-check">
            <input type="radio" name="inlineRadioOptions" v-model="form.type" :value="1">
            Custom Period
          </label>
        </div>

        <div v-if="form.type == 1" class="rf-custom">
          <div class="rf-col">
            <div class="rf-col-title">Days</div>
            <label class="rf-check">
              <input type="checkbox" v-model="form.everday" @change="onEverdayChange()">
              Every Day
            </label>
            <div class="rf-day-list">
              <label class="rf-check"><input type="checkbox" v-model="form.monday"> Monday(s)</label>
              <label class="rf-check"><input type="checkbox" v-model="form.tuesday"> Tuesday(s)</label>
              <label class="rf-check"><input type="checkbox" v-model="form.wednesday"> Wednesday(s)</label>
              <label class="rf-check"><input type="checkbox" v-model="form.thursday"> Thursday(s)</label>
              <label class="rf-check"><input type="checkbox" v-model="form.friday"> Friday(s)</label>
              <label class="rf-check"><input type="checkbox" v-model="form.saturday"> Saturday(s)</label>
              <label class="rf-check"><input type="checkbox" v-model="form.sunday"> Sunday(s)</label>
            </div>
          </div>

          <div class="rf-col">
            <div class="rf-col-title">Time</div>
            <label class="rf-check">
              <input type="checkbox" v-model="form.allDay">
              All Day
            </label>
            <div class="rf-field-pair">
              <div class="rf-field">
                <label>Start time</label>
                <TimeField v-model="form.startTime" width="100%" :disabled="form.allDay" step=1 />
              </div>
              <div class="rf-field">
                <label>End time</label>
                <TimeField v-model="form.endTime" width="100%" :disabled="form.allDay" step=1 />
              </div>
            </div>

            <div class="rf-col-title rf-col-title--spaced">Date</div>
            <label class="rf-check">
              <input type="checkbox" v-model="form.dateSameAsCampaign">
              Same as campaign
            </label>
            <div class="rf-field-pair">
              <div class="rf-field">
                <label>Start Date</label>
                <DateField v-model="form.startDate" width="100%" :disabled="form.dateSameAsCampaign" step=1 />
              </div>
              <div class="rf-field">
                <label>End Date</label>
                <DateField v-model="form.endDate" width="100%" :disabled="form.dateSameAsCampaign" step=1 />
              </div>
            </div>
          </div>
        </div>

        <div class="form-buttons">
          <ButtonCustomized label="Cancel" @click="closeModal" ctaSecondary />
          <ButtonCustomized label="Save" cta @click="onSave" />
        </div>
      </div>
    </template>
  </Dialog>
</template>
    
<script lang="ts" setup>
import Dialog from '../../../components/Dialog/Dialog.vue';
import ButtonCustomized from "../../../components/form-fields/ButtonCustomized.vue";
import PlaylistsLister from '../../PlaylistsListView/PlaylistsLister/PlaylistsLister.vue';
import { onMounted, ref, watch } from 'vue';
import TimeField from '@/components/form-fields/TimeField.vue'
import DateField from '@/components/form-fields/DateField.vue'
const emit = defineEmits(['cancel', 'save', 'exit', 'fail'])
const props = defineProps({
  'campaignTitle': {
    type: String,
    default: ""
  },
  'playlist': {
    type: Object,
    default: null
  }
})
const recurranceModal = ref()
const form = ref({
  type: 0,
  everday: true,
  sunday: true,
  monday: true,
  tuesday: true,
  wednesday: true,
  thursday: true,
  friday: true,
  saturday: true,
  startTime: "00:00:00",
  endTime: "23:59:59",
  allDay: true,
  startDate: null,
  endDate: null,
  dateSameAsCampaign: true
})
onMounted(() => {
  fillModel();

})
watch(
  () => ({
    monday: form.value.monday,
    tuesday: form.value.tuesday,
    wednesday: form.value.wednesday,
    thursday: form.value.thursday,
    friday: form.value.friday,
    saturday: form.value.saturday,
    sunday: form.value.sunday
  }),
  (newValue) => {
    if(!newValue.monday || !newValue.tuesday || !newValue.wednesday || 
      !newValue.thursday || !newValue.friday || !newValue.saturday || 
      newValue.sunday){
        form.value.everday = false;
      }
    if (
      newValue.monday && newValue.tuesday && newValue.wednesday && 
      newValue.thursday && newValue.friday && newValue.saturday && 
      newValue.sunday
    ) {
      form.value.everday = true;
    }

  },
  { deep: true }
);
function onEverdayChange() {
  if (form.value.everday) {
    form.value.monday = true
    form.value.tuesday = true
    form.value.wednesday = true
    form.value.thursday = true
    form.value.friday = true
    form.value.sunday = true
    form.value.saturday = true
  } else {
    form.value.monday = false
    form.value.tuesday = false
    form.value.wednesday = false
    form.value.thursday = false
    form.value.friday = false
    form.value.sunday = false
    form.value.saturday = false
  }
}

function fillModel() {
  form.value.everday = props.playlist.weekdays == 127 ? true : false
  form.value.startTime = props.playlist.startTime.slice(0, 8)
  form.value.endTime = props.playlist.endTime.slice(0, 8)
  form.value.startDate = props.playlist.startDate == null ? null : new Date(props.playlist.startDate+" UTC").toISOString().slice(0,10);
  form.value.endDate = props.playlist.endDate == null ? null : new Date(props.playlist.endDate+" UTC").toISOString().slice(0,10);
  if (!form.value.everday) {
    form.value.saturday = (props.playlist.weekdays & 64) > 0 ? true : false
    form.value.sunday = (props.playlist.weekdays & 1) > 0
    form.value.monday = (props.playlist.weekdays & 2) > 0
    form.value.tuesday = (props.playlist.weekdays & 4) > 0
    form.value.wednesday = (props.playlist.weekdays & 8) > 0
    form.value.thursday = (props.playlist.weekdays & 16) > 0
    form.value.friday = (props.playlist.weekdays & 32) > 0
  }
  if (form.value.startTime == "00:00:00" && form.value.endTime == "23:59:59") {
    form.value.allDay = true
  } else {
    form.value.allDay = false
  }
  if (form.value.startDate == null && form.value.endDate == null) {
    form.value.dateSameAsCampaign = true
  } else {
    form.value.dateSameAsCampaign = false
  }
  if (form.value.everday && form.value.allDay && form.value.dateSameAsCampaign) {
    form.value.type = 0
  } else {
    form.value.type = 1
  }
}
function bindModel() {

  if (form.value.type == 0) {
    return {
      weekdays: 127,
      startTime: "00:00:00",
      endTime: "23:59:59",
      startDate: null,
      endDate: null
    }
  } else {
    let weekdays = 0;
    if (form.value.friday) {
      weekdays += 32
    }
    if (form.value.saturday) {
      weekdays += 64
    }
    if (form.value.sunday) {
      weekdays += 1
    }
    if (form.value.monday) {
      weekdays += 2
    }
    if (form.value.tuesday) {
      weekdays += 4
    }
    if (form.value.wednesday) {
      weekdays += 8
    }
    if (form.value.thursday) {
      weekdays += 16
    }
    return {
      weekdays: weekdays,
      startTime: form.value.allDay ? '00:00:00' : form.value.startTime,
      endTime: form.value.allDay ? '23:59:59' : form.value.endTime,
      startDate: form.value.dateSameAsCampaign ? null : form.value.startDate,
      endDate: form.value.dateSameAsCampaign ? null : form.value.endDate
    }
  }


}
function onExit() {
  emit('exit')
}
async function onSave() {
   emit('save', bindModel());
    recurranceModal.value.closeModal()
}

</script>
    
<style lang="scss" scoped>
.recurrence-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  min-width: min(34rem, calc(100vw - 6rem));
  color: var(--bui-tbl-row-text, #2a2969);
}

.rf-type-row {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.rf-label {
  font-weight: 700;
  font-size: 0.875rem;
}

.rf-check {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.875rem;
  cursor: pointer;

  input[type='checkbox'],
  input[type='radio'] {
    width: 15px;
    height: 15px;
    margin: 0;
    accent-color: var(--bui-chk-checked-fill, #de3da9);
    cursor: pointer;
  }
}

.rf-custom {
  display: grid;
  grid-template-columns: 1fr 1.4fr;
  gap: 1.5rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
}

.rf-col {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  min-width: 0;
}

.rf-col-title {
  font-weight: 700;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--bui-tbl-detail-text, #5c5c66);

  &--spaced {
    margin-top: 0.75rem;
  }
}

.rf-day-list {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
  margin-left: 1.4rem;
}

.rf-field-pair {
  display: flex;
  gap: 0.75rem;

  .rf-field {
    flex: 1 1 0;
    min-width: 0;

    > label {
      display: block;
      font-size: 0.8rem;
      font-weight: 600;
      margin-bottom: 2px;
    }
  }
}

/* Token-colour the legacy time/date field atoms. */
.rf-field {
  :deep(input) {
    color: var(--bui-ter-input-text, #1a1a1e);
    background: var(--bui-ter-input-fill, rgba(0, 0, 0, 0.04));
    border-color: var(--bui-ter-input-border, rgba(0, 0, 0, 0.12));
    width: 100%;
  }
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 0.5rem;
}
</style>